module.exports = __webpack_public_path__ + "static/blur.4821155b.jpg";